import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { ADMIN_FEATURE_GROUP } from './group';

export const ADMIN_FEATURES = {
  RUN_AS: {
    guid: 'a7f2b3c1-9e4d-4a8f-b620-5c1e3d7f0001',
    name: 'admin:run-as',
    description: 'Impersonate any user within the platform',
    action: 'read',
    product: 'account',
    parentGuid: ADMIN_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ADMIN_FEATURE_GROUP } from './group';

export const ADMIN_MODULE: FeatureModule = {
  product: 'account',
  groups: [ADMIN_FEATURE_GROUP],
  features: featureList(ADMIN_FEATURES),
};
